<template>
	<div>
		<div class="content">
			<div class="card">
				<div class="card-body">
					<div v-if="!selectedPaymentMethod" class="default modern">
						<h1 style="font-size: 18px !important;">FORMAS DE PAGAMENTO</h1>
						<span class="subtitle f-14">Adicione e remova as formas de pagamento financeiras aqui</span>


						<table class="table table-hover table-md f-13">
						  	<thead class="thead-default">
								<tr>
									<th style="width: 90%">NOME</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(payment_method, index) in payment_methods">
									<tr :key="index" class="root pt-5" @click="edit(payment_method)">
										<td class="root-title pointer">{{ payment_method.name }}</td>
									</tr>
								</template>
								<tr>
									<td colspan="2" class="node new" @click="create()">+ Adicionar nova forma de pagamento</td>
								</tr>
							</tbody>	
						</table>

					</div>

					<finances-payment-method-component ref="financesPaymentMethodComponent" @onCancelled="onCancelled($event)"></finances-payment-method-component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FinancesPaymentMethodComponent  from './PaymentMethod/FinancesPaymentMethodComponent'
	import FinancesPaymentMethod from '@/models/FinancesPaymentMethod'
	import FinancesPaymentMethodService from '@/services/FinancesPaymentMethodService'

	export default {
		components: {
			FinancesPaymentMethodComponent
		},
		data() {
			return {
				payment_methods: [],
				selectedPaymentMethod: null,
			}
		},
		methods: {
			loadPaymentMethods() {
				FinancesPaymentMethodService.load('?order=true').then(res => {
					this.payment_methods = res.data
				})
				.catch(err => {

				})
			},
			reload() {
				this.loadPaymentMethods()
			},
			create(parent) {

				let model;

				if(parent)  {
					model = new FinancesPaymentMethod({ type: parent.type })
					model.parent_id = parent.id;
				}
				else {
					model = new FinancesPaymentMethod({ type: this.type })
				}


				this.select(model)
			},

			select(payment_method) {
				this.$refs.financesPaymentMethodComponent.open(payment_method)
				this.selectedPaymentMethod = payment_method
			},

			edit(payment_method) {
				this.select(payment_method)
			},
			onCancelled(bool) {
				this.selectedPaymentMethod = null;
				this.reload()
			},
			changeType(type){
				this.type = type;
			}
		},
		mounted() {
			this.reload()
		}
	}
</script>
<style>
	.root {
		padding-top: 15px !important;
	}

	.root-title {
		color: #0079bf;
		font-weight: bold;
	}

	.root-title.red {
		color: red;
	}

	.node {
		padding-left: 40px;
		cursor: pointer;
	}

	.node.new {
		color: #888;
	}

	.node.blank {
		border: 0;
		height: 35px;
	}

	.node.blank:hover {
		background-color: white;
	}
</style>